<template>
    <div class="card-header">
      <div class="row">
        <div class="col-10">
          <label style="position:relative; margin-right: 30%;">
            <span v-if="mode.toLowerCase() === 'editor'"><i class="fas fa-edit"></i></span>
<span v-if="mode.toLowerCase() === 'preview'"><i class="fas fa-eye"></i></span>
            
            {{mode}} : {{ elementLabel }}</label>
        </div>
        <div class="col-2 badgeTypePosition">
          <span class="badge bg-info">{{ elementType }}</span>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  defineProps({
    elementLabel: {
      type: String,
      default: ''
    },
    elementType: {
      type: String,
      default: ''
    }, mode:{
      type: String,
      required: true
    }
  });
  </script>
  
  <style scoped>
  .badgeTypePosition {
    text-align: right;
  }

  .card-header{
    color: #fff;
    background-color: #426C9C;
  }
  </style>